import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import type { ProjectTab } from "../ProjectTabs";

interface TabLinkInlineProps {
  projectId: string;
  tab: ProjectTab;
  children: ReactNode;
}

export function TabLinkInline({
  projectId,
  tab,
  children,
}: TabLinkInlineProps) {
  return (
    <Link
      to="/projects/$projectId"
      params={{ projectId }}
      search={(prev) => ({ ...prev, tab })}
      className="text-primary hover:underline"
    >
      {children}
    </Link>
  );
}
